// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"4fae5dcf","24":"e6d015e2","78":"3eb45746","264":"ff06ad26","334":"20e66558","447":"6f5adb95","577":"58752eb2","787":"20a4d715","936":"63107a4d"}[chunkId] + ".chunk.js";
};